import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";
import { useParams } from "react-router-dom";
import CreatureCard from "./../components/CreatureCard";

const Party = () => {
  const [partyData, setPartyData] = useState(false);
  let { partyid } = useParams(); // Unpacking and retrieve id

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    console.log(partyData);
  }, [partyData]);

  const getData = () => {
    axios
      .get(
        `https://creatureparty.net/dashboard/wp-json/creatureparty/v1/parties/${partyid}`
      )
      .then((res) => setPartyData(res.data))
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <section className={`Party`}>
        {partyData ? (
          <>
            <div className="Party__Banner">
              <img src={partyData.info.banner.large} />
            </div>

            { partyData.attendees.length ? (
              <div className={`Party__Creatures  ${partyData.attendees.length > 2 ? "Party__Creatures--Many" : "Party__Creatures--Few"}`}>
                {partyData.attendees.map((creatureData, i) => (
                  <CreatureCard key={`creature${i}`} data={creatureData} />
                ))}
              </div>
            ) : (
              <div className="Party__Empty">
                <h3>We anxiously awaited the guests...</h3>
              </div>
            )}
          </>
        ) : null}
      </section>
    </Layout>
  );
};

export default Party;
